import * as React from "react";
import PropTypes from "prop-types";
import GBStdTable from "../../../Library/Tables/GBStdTable";
import * as SCConst from "../NonComponents/SCConst.js";
import { getCategoryName } from "../NonComponents/SCDataUtil.js";

class SCPersFacTable extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        catInfo: PropTypes.object,
        mstIDsObj: PropTypes.object,
        value: PropTypes.arrayOf(PropTypes.array),
        onChange: PropTypes.func,
    };

    static defaultProps = {
        catInfo: null,
        value: [
            ["", "Value"],
            ["# Surgical Beds", 1],
            ["Current # VMMC Providers", 2],
            ["Current # Assistant", 3],
            ["Other Nurses", 4],
            ["Current # Community Health Workers/Mobilisers", 5],
            ["Current # Counselors", 6],
        ],
        onChange: () => console.log("onChange"),
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {
        try {
            let MAX_VALUE = 999999999;

            let styles = {
                innerPage: {
                    margin: 20,
                },
            };

            const catName = getCategoryName(SCConst.cat_PersFacMstID, this.props.catInfo, this.props.mstIDsObj);

            let values = JSON.parse(JSON.stringify(this.props.value));

            return (
                <div style={styles.innerPage}>
                    <h5>{catName}</h5>

                    <p style={{ fontSize: 12 }}>
                        1 individual = 1 FTE if s/he is full time; 3 individuals = 1.5 FTE if each works half time
                    </p>

                    <GBStdTable
                        id="CapacityTable"
                        minHeight={220}
                        maxHeight={220}
                        packTable={{
                            GBFixedRows: 1,
                            GBFixedCols: 1,
                            GBRowCount: 7,
                            GBColCount: 2,
                            GBColWidths: [300, 70],
                            GBRowHeights: [-1, -1, -1, -1, -1, -1, -1],
                            MinAllowedVal: [
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                            ],
                            MaxAllowedVal: [
                                [0, 0],
                                [0, MAX_VALUE],
                                [0, MAX_VALUE],
                                [0, MAX_VALUE],
                                [0, MAX_VALUE],
                                [0, MAX_VALUE],
                                [0, MAX_VALUE],
                            ],
                            tableData: {
                                value: values,
                            },
                            AllowBlanks: true, // mark
                        }}
                        onSheetCellsChanged={this.props.onChange}
                    />
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"SCPersFacTableDiv"}
                    key={"SCPersFacTableDiv"}
                >
                    <h3 key={"SCPersFacTableDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default SCPersFacTable;
